export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2025-01-21'

export const dataset = assertValue(
  process.env.NEXT_PUBLIC_SANITY_DATASET,
  'Missing environment variable: NEXT_PUBLIC_SANITY_DATASET'
)

export const projectId = assertValue(
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  'Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID'
)

export const token =
  typeof window === 'undefined'
    ? assertValue(
      process.env.SANITY_API_READ_TOKEN,
      'Missing environment variable: SANITY_API_READ_TOKEN'
    )
    : undefined

// Viewer-only token exposed to editors' browsers in draft mode; without it SanityLive doesn't stream draft changes.
export const browserToken =
  typeof window === 'undefined' ? process.env.SANITY_API_BROWSER_TOKEN || false : false

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage)
  }

  return v
}
